module.exports = __webpack_public_path__ + "static/img/hardCT1.14d674fb.png";